import { render, staticRenderFns } from "./NewsFour.vue?vue&type=template&id=274d2018&scoped=true&"
import script from "./NewsFour.vue?vue&type=script&lang=ts&"
export * from "./NewsFour.vue?vue&type=script&lang=ts&"
import style0 from "./NewsFour.vue?vue&type=style&index=0&id=274d2018&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d2018",
  null
  
)

export default component.exports